import { useLocation } from "react-router-dom";

/**
 * The address a guard sent the learner away from, so the sign-in chain can put them back where
 * they were trying to go. Carried in router state; the sign-in screens pass it along.
 */
export function useRedirectTarget(): string | undefined {
  const location = useLocation();
  const state = location.state as { from?: string } | null;
  if (!state?.from) return undefined;
  // Only in-app paths, never an absolute URL from somewhere else.
  if (!state.from.startsWith("/") || state.from.startsWith("//")) return undefined;
  if (state.from.startsWith("/sign-in") || state.from.startsWith("/mfa")) return undefined;
  return state.from;
}
